export const namespace = 'venue'
